
const state = {
    collectionQ: "kb",
    collectionK: "kb_kategorien",
    all: [],
    categories: [],
    ready: false,
    updating: false
}

const getters = {
    all: (state) => state.all,
    readyState: (state) => state.ready,
    updateState: (state) => state.updating,
    categories: (state) => state.categories
}

const actions = {
    async init({ commit, dispatch }) {
        try {
            await dispatch("getQuestions");
            await dispatch("getCategories");
            commit("setReadyState");
        } catch(error) {
            console.log(error);
            throw error;
        }
    },
    async getQuestions({ commit }) {
        try {            
            const response = await this._vm.$directus.getItems(state.collectionQ);
            commit("setQuestions", response.data);
        } catch(error) {
            console.log(error);
            throw error;
        } 
    },
    async getCategories({ commit }) {
        try {
            const response = await this._vm.$directus.getItems(state.collectionK);
            commit("setKategorien", response.data);
        } catch(error) {
            console.log(error);
            throw error;
        }
    },
    async createNewTopic(_, payload) {
        try {
            this._vm.$directus.createItem(state.collectionQ, payload);
        } catch(error) {
            console.log(error);
            throw error;
        }
    },
    async createNewCategory({ dispatch }, payload) {
        const createPayload = {
            ...payload, 
            status: "published"
        }
        try {
            await this._vm.$directus.createItem(state.collectionK, createPayload);
        } catch(error) {
            const parsed = await dispatch("app/parseError", error, {root:true});
            console.log(parsed);
            throw "Fehler beim Erstellen der Kategorie";
        }
    }, 
    async deleteCategory({ dispatch }, catId) {
        try {
            await this._vm.$directus.deleteItem(state.collectionK, catId);
        } catch(error) {
            const parsed = await dispatch("app/parseError", error, {root:true});
            console.log(parsed);
            throw "Fehler beim Löschen der Kategorie";
        }
    }

}

const mutations = {
    setUpdateState: (state) => state.updating = true,
    unsetUpdateState: (state) => state.updating = false,
    setQuestions: (state, questions) => state.all = questions,
    setReadyState: (state) => state.ready = true,
    unsetReadyState: (state) => state.ready = false,
    setKategorien: (state, categories) => state.categories = categories
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};